"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inquiryType = void 0;
var utils_1 = require("../../utils");
exports.inquiryType = function (axios) {
    return {
        // [Inquiry ]
        // 查询全部咨询类型
        getInquiryType: function (getInquiryTypeRequest) {
            return axios.get('/inquiry-types', getInquiryTypeRequest);
        },
        // 添加咨询类型
        postInquiryTypes: function (postInquiryTypeRequest) {
            return axios.post('/inquiry-types', postInquiryTypeRequest.data);
        },
        // 咨询类型详细查询
        getInquiryTypesInquiryTypeNo: function (getInquiryTypesInquiryTypeNoRequest) {
            var url = utils_1.paramPathchange("/inquiry-types/{inquiryTypeNo}", getInquiryTypesInquiryTypeNoRequest);
            return axios.get(url, getInquiryTypesInquiryTypeNoRequest);
        },
        // 修改咨询类型
        putInquiryTypesInquiryTypeNo: function (putInquiryTypesInquiryTypeNoRequest) {
            var url = utils_1.paramPathchange("/inquiry-types/{inquiryTypeNo}", putInquiryTypesInquiryTypeNoRequest);
            return axios.put(url, putInquiryTypesInquiryTypeNoRequest.data);
        },
        // 删除咨询类型
        deleteInquiryTypesInquiryTypeNo: function (deleteInquiryTypesInquiryTypeNoRequest) {
            var url = utils_1.paramPathchange("/inquiry-types/{inquiryTypeNo}", deleteInquiryTypesInquiryTypeNoRequest);
            return axios.delete(url, deleteInquiryTypesInquiryTypeNoRequest);
        },
        // 咨询类型順序修正
        putInquiryTypesInquiryTypeNoOrder: function (putInquiryTypesInquiryTypeNoOrderRequest) {
            var url = utils_1.paramPathchange("/inquiry-types/{inquiryTypeNo}/order", putInquiryTypesInquiryTypeNoOrderRequest);
            return axios.put(url, putInquiryTypesInquiryTypeNoOrderRequest.data);
        }
    };
};
